import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppAsideModule, AppBreadcrumbModule, AppFooterModule } from '@coreui/angular';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxGalleryModule } from 'ngx-gallery-14';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SegmentModule } from 'ngx-segment-analytics';
import { TypeaheadModule } from 'ngx-type-ahead';
import { env } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AuthInterceptor } from './auth.interceptor';
import { BaseURLInterceptor } from './baseurl.interceptor';
import { DefaultLayoutComponent } from './containers';
import { AppSidebarModule } from './containers/custom/sidebar';
import { EncodeInterceptor } from './encode.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { InspectionModule } from './inspection/inspection.module';
import { LoaderInterceptor } from './loader.interceptor';
import { QuestionModule } from './question/question.module';
import { SentryErrorHandler } from './sentry.error.handler';
import { SettingModule } from './setting/setting.module';
import { AuthGuard } from './shared/auth.guard';
import { AuthService } from './shared/auth.service';
import { SharedModule } from './shared/shared.module';
import { UserModule } from './user/user.module';
import { DownloadComponent } from './views/download/download.component';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { ForgotComponent } from './views/forgot/forgot.component';
import { LoginComponent } from './views/login/login.component';
import { RecoverComponent } from './views/recover/recover.component';
import { RegisterComponent } from './views/register/register.component';
import { WelcomeComponent } from './views/welcome/welcome.component';
import { InspectionGalleryPopupComponent } from './inspection/inspection-gallery-popup/inspection-gallery-popup.component';
import { HazardHubReportPageComponent } from './spatial-analysis/hazard-hub-report/hazard-hub-report-page.component';

const segmentWriteKey =
  location.host === 'dashboard.losscontrol.plus' ? env.segmentWriteKeyProduction : env.segmentWriteKeyTesting;

@NgModule({
  imports: [
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    TabsModule.forRoot(),
    SharedModule,
    UserModule,
    QuestionModule,
    SettingModule,
    TypeaheadModule,
    InspectionModule,
    SegmentModule.forRoot({ apiKey: segmentWriteKey, debug: true, loadOnInitialization: true }),
    NgxGalleryModule,
  ],
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    ForgotComponent,
    RecoverComponent,
    InspectionGalleryPopupComponent,
    HazardHubReportPageComponent,
    DownloadComponent,
    WelcomeComponent,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseURLInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    AuthGuard,
    AuthService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
